

import type { ValidationSchema } from '@wix/editor-elements-corvid-utils';
import { createComponentSDKModel } from '@wix/editor-elements-integrations/corvid';
import { createLeanComponentSDK } from '@wix/lean-components-infra/runtime/sdk';
import type { ILogoProps } from '../../../components/Logo/Logo.props';

const sdkSchema = {
  "isLoadingData": {
    "type": "boolean",
    "persistence": "multiLangVar"
  },
  "logoId": {
    "type": "string",
    "persistence": "multiLangVar"
  },
  "alt": {
    "type": "string",
    "persistence": "multiLangVar"
  },
  "link": {
    "type": "object",
    "persistence": "multiLangVar"
  },
  "preset": {
    "type": "string",
    "persistence": "multiLangVar"
  },
  "hasBackground": {
    "type": "boolean",
    "persistence": "multiLangVar"
  },
  "brandId": {
    "type": "string",
    "persistence": "multiLangVar"
  },
  "backgroundColor": {
    "type": "string",
    "persistence": "multiLangVar"
  },
  "logoUrl": {
    "type": "string",
    "persistence": "multiLangVar"
  }
};

const validationSchema: ValidationSchema = {
  "type": [
    "object"
  ],
  "properties": {
    "isLoadingData": {
      "type": [
        "boolean"
      ]
    },
    "logoId": {
      "maxLength": 120,
      "type": [
        "string"
      ]
    },
    "alt": {
      "maxLength": 120,
      "type": [
        "string"
      ]
    },
    "link": {
      "type": [
        "object"
      ]
    },
    "preset": {
      "maxLength": 120,
      "type": [
        "string"
      ]
    },
    "hasBackground": {
      "type": [
        "boolean"
      ]
    },
    "brandId": {
      "maxLength": 120,
      "type": [
        "string"
      ]
    },
    "backgroundColor": {
      "maxLength": 120,
      "type": [
        "string"
      ]
    },
    "logoUrl": {
      "maxLength": 1200,
      "type": [
        "string"
      ]
    }
  }
};

const mixins = null;

export const sdk = createLeanComponentSDK<ILogoProps>({
  sdkSchema,
  validationSchema,
  mixins
});

export default createComponentSDKModel(sdk);

